<template>
  <!-- <b-container>
    <b-card align="center" border-variant="success" style="margin-top: 50%">
      <loading
        :active.sync="isLoading"
        color="#14df11"
        loader="bars"
        :is-full-page="fullPage"
        width:2
        height:2
      ></loading>
      <b-card-title style="text-align: center"><b>Login</b></b-card-title>
      <b-form>
        <div class="row">
          <div class="col-xs-12 col-md-12">
            <b-form-input
              id="input-1"
              v-model="username"
              maxlength="10"
              required
              placeholder="Mobile No"
            >
            </b-form-input>
          </div>

          <div class="col-xs-12 col-md-12" style="margin-top: 10px">
            <otp-input
              v-model="password"
              :digits="4"
              style="margin-left: 20px"
              @on-complete="onCompleteHandler"
              v-if="show_otp"
            >
              <template #errorMessage> There is an error </template>
            </otp-input>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-xs-4 ml-3">
            <b-button variant="success" @click="otp()">Generate OTP</b-button>
          </div>
          <div class="col-xs-4">
            <b-button
              variant="primary"
              @click="login()"
              class="ml-3"
              v-if="show_otp"
              >Login</b-button
            >
          </div>
        </div>

        <b-button variant="warning" @click="TEST" class="ml-3">TEST</b-button>
      </b-form>
    </b-card>
  </b-container> -->

  <div class="wrapper fadeIn">
    <loading
        :active.sync="isLoading"
        color="#51c569"
        loader="bars"
        :is-full-page="fullPage"
        width:2
        height:2
      ></loading>
  <div id="formContent">
    <!-- Tabs Titles -->

    <!-- Icon -->
    <div class="fadeIn first">
      <img src="img/icons/dairyfarm.png" id="icon" alt="User Icon" />
    </div>

    <!-- Login Form -->
    <form style="margin-bottom:5%">
      <input onkeypress="return event.charCode >= 48 && event.charCode <= 57"  maxlength="10" v-model="username" type="text" id="login" class="fadeIn second" name="login" placeholder="Mobile No">
      <otp-input
      class="fadeIn second"
              v-model="password"
              :digits="4"
              style="margin-left: 25%"
              @on-complete="onCompleteHandler"
              v-if="show_otp"
            >
              <template #errorMessage> There is an error </template>
            </otp-input>
      <!-- <input type="button" class="fadeIn fourth" value="Generate OTP" @click="otp()"> -->
      
         
            <b-button style="color:white;background-color:#51c569;margin-top:5%" class="fadeIn second" type="button" variant="success" @click="otp()">Send OTP</b-button>
          
          
            <b-button
            
              type="button"
              style="margin-top:5%"
              variant="primary"
              @click="login()"
              class="ml-3 fadeIn second"
              v-if="show_otp"
              >Login</b-button
            >

            <!-- <b-button  style="margin-top:5%" variant="warning" @click="TEST" class="ml-3">TEST</b-button> -->
          
       
    </form>

    <!-- Remind Passowrd -->
    <!-- <div id="formFooter">
      <a class="underlineHover" href="#">Forgot Password?</a>
    </div> -->

  </div>
</div>


</template>

<script>
import apis from "@/apis";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SimpleOtpInput from "vue-simple-otp-input";
import OtpInput from "otp-input-vue2";

import {
  blockShimmer,
  circleShimmer,
  imageShimmer,
  paragraphsShimmer,
  sentencesShimmer,
  textShimmer,
} from "vue-shimmer";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      show_otp: false,
      username: "",
      password: "",
    };
  },
  methods: {
    onCompleteHandler(data) {
      this.password = data;
    },
    TEST() {
      this.$router.push("/home");
    },
    login() {
      if (this.password) {
        this.isLoading = true;
        let data = {
          PhoneNumber: this.username,
          otp: this.password,
          DeviceId: "123456",
        };
        var promise = apis.verifyotp(data);
        promise
          .then((response) => {
            this.isLoading = false;

            if ((response.data.statusCode = 200)) {
              var addressId = response.data.societydetails[0].addressId;
              var society_id = parseInt(response.data.societydetails[0].id);
             // alert(society_id);
              var id = response.data.id;
              var roleId = response.data.roleId;
              var roleName = response.data.roleName;
              var token = response.data.token;
              localStorage.token = token;
              this.$session.start();
              this.$session;
              this.$session.set("addressId", addressId);
              this.$session.set("id", id);
              this.$session.set("society_id", society_id);
              this.$session.set("roleId", roleId);
              this.$session.set("roleName", roleName);
              this.$session.set("token", token);
              this.$session.set("username", this.username);

              localStorage.setItem('addressId',addressId);
              localStorage.setItem('id',id);
              localStorage.setItem('society_id',society_id);
              localStorage.setItem('roleId',roleId);
              localStorage.setItem('roleName',roleName);
              localStorage.setItem('token',token);
              localStorage.setItem('username',this.username);
              

              this.$router.push("/home");
              window.location.reload(true);
            } else {
              this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: '400px',
                    confirmButtonColor: "green"
                    
                    })
              this.onReset();
            }
          })
          .catch((error) => {
            this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error,
                    width: '400px',
                    confirmButtonColor: "green"
                    
                    })
          });
      } else {
        alert("Please Generate OTP");
      }
    },
    otp() {
      if (this.username==null || this.username==undefined || this.username=='') {

        this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Please Enter Mobile No.',
                    width: '400px',
                    confirmButtonColor: "green"
                    
                    })
                    return false;
      }
      this.isLoading = true;
      let data = {
        PhoneNumber: this.username,
      };
      var promise = apis.sendotp(data);
      promise
        .then((response) => {
          this.isLoading = false;
          if ((response.data.status == true)) {
            this.show_otp = true;
          } else {
            this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message,
                    width: '400px',
                    confirmButtonColor: "green"
                    })
            this.onReset();
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
    onReset() {
      this.show_otp = false;
      this.username = "";
      this.password = "";
    },
  },
  mounted() {},
  components: {
    Loading,
    blockShimmer: blockShimmer,
    circleShimmer: circleShimmer,
    imageShimmer: imageShimmer,
    paragraphsShimmer: paragraphsShimmer,
    sentencesShimmer: sentencesShimmer,
    textShimmer: textShimmer,
    SimpleOtpInput,
    OtpInput,
  },
 created()
 {
  if(localStorage.length>0)
  {
    //console.log(localStorage);
    this.$router.push("/home");
  }
 }
  
};
</script>

<style scoped>
/* BASIC */

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display:inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display:inline-block;
  margin: 40px 8px 10px 8px; 
  color: #cccccc;
}



/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  margin-top: 10%;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}



/* FORM TYPOGRAPHY*/

input[type=button], input[type=submit], input[type=reset]  {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover  {
  background-color: #39ace7;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type=text] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
  color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after{
  width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
} 

#icon {
  width:60%;
}


</style>
